module.exports = function() {
  return new Worker(__webpack_public_path__ + "62b21b2ad55704cebe50.worker.js");
};